/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactCategory as FeatureContactsContactCategory } from '../../models/feature/contacts/contact-category';
import { ContactDto as FeatureContactsContactDto } from '../../models/feature/contacts/contact-dto';

export interface GetAllContacts$Params {
  category?: FeatureContactsContactCategory | null;
}

export function getAllContacts(http: HttpClient, rootUrl: string, params?: GetAllContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureContactsContactDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllContacts.PATH, 'get');
  if (params) {
    rb.query('category', params.category, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<Array<FeatureContactsContactDto>>;
    })
  );
}

getAllContacts.PATH = '/contacts';

function reviveFeatureContactsContactDto(value: any): any {
  if (value) {
    if (value["archivedOn"] != null) {
      value["archivedOn"] = parseDateTime(value["archivedOn"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body) {
    for (let i0 = 0; i0 < body.length; i0++) {
      if (body[i0] != null) {
        body[i0] = reviveFeatureContactsContactDto(body[i0]);
      }
    }
  }
  return body;
}
